import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ViewService } from '../../view.service';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { LayoutService } from '../../layout.service';
import { ViewLayout } from '../../models/view-layout.enum';
import { ViewState } from '../../state/view.state';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-view-content-mode',
  templateUrl: './view-content-mode.component.html',
  styleUrls: ['./view-content-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewContentModeComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(StoryChaptersState.getStoryChapters)
  chapters$: Observable<ChapterModel>;

  @Select(StoryLabelsState.getChapterLabels)
  labels$: Observable<LabelModel[]>;

  private ngUnsubscribe = new Subject();
  
  
  // ---------- Input / Output ----------
  @Input()
  layout: 'drawer' | 'column' = 'column';
  
  
  // ---------- Class Variables ----------
  viewLayout = ViewLayout;
  


  // ---------- Lifecyle Events ----------
  constructor(
    private store: Store,
    private viewService: ViewService,
    private layoutService: LayoutService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.store
      .select(ViewState.getLayout)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  // ---------- Layout ----------
  isVisible(layout: ViewLayout) {
    return this.layoutService.isLayoutVisible(layout);
  }

  isEnabled(layout: ViewLayout) {
    return this.layoutService.isLayoutEnabled(layout);
  }
  
  
  // ---------- Interaction ----------
  handlePrevClick() {
    this.selectLabel(-1);
  }

  handleNextClick() {
    this.selectLabel(1);
  }

  selectLabel(increment: number) {
    const labels = this.store.selectSnapshot(StoryLabelsState.getChapterLabels);
    const labelCount = labels.length;
    const selectedLabelId = this.store.selectSnapshot(StoryLabelsState.getSelectedLabelId);
    const selectedLabelIndex = labels.findIndex((label) => label.id === selectedLabelId);
    
    // get next index
    const nextIndex = selectedLabelIndex !== -1
      // increment
      ? selectedLabelIndex + increment
      // defafult
      : 0;

    // cycle target index in range
    const targetLabelIndex = (nextIndex % labelCount + labelCount) % labelCount;

    // get target label
    const targetLabel = labels[targetLabelIndex];
    if (targetLabel) {
      this.viewService.selectLabel(targetLabel, true);
    }
  }

}
